const en = {
  b5: {
    nav: { home: "Home", learning: "Learning", methodology: "Methodology", author: "Author", cases: "Cases", catalogue: "Catalogue", demo: "Demo", help: "Help", sign_in: "Sign in" },
    explore_demo: "Explore Demo — no registration",
    sec_learning: "Courses and educational materials", sec_method: "Methodology and author", sec_cases: "Public cases", sec_demo: "Interactive demo", sec_tools: "Practice tools and cosmetics catalogue",
    open_page: "Open: {{title}}", all_cases: "All public cases", open_catalogue: "Open the catalogue",
    back_to: "Back to {{section}}", demo_status: "Demo", demo_role: "Current role: {{role}}", exit_demo: "Exit demo",
    home_learning: "Learning", home_learning_sub: "Courses, lessons and practical assignments.", home_learning_open: "Open Learning",
  },
};

const ru = {
  b5: {
    nav: { home: "Главная", learning: "Обучение", methodology: "Методология", author: "Автор", cases: "Кейсы", catalogue: "Каталог", demo: "Демо", help: "Помощь", sign_in: "Войти" },
    explore_demo: "Открыть демо — без регистрации",
    sec_learning: "Курсы и учебные материалы", sec_method: "Методология и автор", sec_cases: "Публичные кейсы", sec_demo: "Интерактивное демо", sec_tools: "Инструменты практики и каталог косметики",
    open_page: "Открыть: {{title}}", all_cases: "Все публичные кейсы", open_catalogue: "Открыть каталог",
    back_to: "Назад: {{section}}", demo_status: "Демо", demo_role: "Текущая роль: {{role}}", exit_demo: "Выйти из демо",
    home_learning: "Обучение", home_learning_sub: "Курсы, уроки и практические задания.", home_learning_open: "Открыть обучение",
  },
};

export default { en, ru };
